import { FC } from 'react';

interface BracketProps {
  type: 'left' | 'right';
  variant?: 'expression' | 'list';
}

/**
 * Component that displays brackets for expressions and lists
 */
export const Bracket: FC<BracketProps> = ({ type, variant = 'expression' }) => {
  const isExpression = variant === 'expression';
  
  return (
    <span
      style={{
        fontWeight: isExpression ? 700 : 400,
        color: isExpression ? '#000' : '#3b82f6',
        fontSize: '1rem',
      }}
    >
      {type === 'left' ? '[' : ']'}
    </span>
  );
};
